<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <imgBigCards path="/layout/list/teacherHand"></imgBigCards>

    <div class="title-box">
      <div class="title">
        <div class="title-left">
          <!-- 面包屑 -->
          <el-breadcrumb>
            <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
            <el-breadcrumb-item to="/layout/list/teacherHand"
              >教师助手</el-breadcrumb-item
            >
            <el-breadcrumb-item to="/layout/list/collaborativeMediaDetails"
              >教研合作媒体</el-breadcrumb-item
            >
            <el-breadcrumb-item>正文</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
       
        <!-- 加入收藏 -->
        <div
          v-if="mydata.articleInfo.is_collect === 0"
          class="title-right"
          @click="isCollect"
        >
          <el-icon><Star /></el-icon>
          <p>加入收藏</p>
        </div>
        <!-- 取消收藏 -->
        <div v-else class="title-right" @click="isCollect">
          <el-icon class="collectTrue"><Star /></el-icon>
          <p class="collectTrue">取消收藏</p>
        </div>
      </div>
    </div>

    <div class="box-content">
      <div class="content-left">
        <div class="left-one">
          <div class="one-title">
            <p>
              {{ mydata.articleInfo.title }}
            </p>
            <P>
              <span
                >发表时间：
                <!-- 2023-11-07 -->
                <!-- 后端会返回 10位的数字===秒   13位的数字===毫秒 -->
                {{
                  dayjs(mydata.articleInfo.release_time * 1000).format(
                    "YYYY-MM-DD"
                  )
                }}
              </span>
              <span style="margin-right: 34px"
                >来源：{{ mydata.articleInfo.source }}</span
              >
              <span
                >关键词：
                <span
                  v-for="(item, index) in mydata.articleInfo.tags"
                  :key="index"
                  style="margin-right:10px;"
                  >{{ item.name }}</span
                >
              </span>
            </P>
          </div>
          <div class="one-content">
            <!-- <img src="@/assets/image 13 (1).png" alt="" /> -->
            <!-- <img
              v-complete:src="mydata.articleInfo.image"
              alt=""
            /> -->
            <p class="tableA" v-html="mydata.articleInfo.content"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Calendar } from "@element-plus/icons-vue";
import { View } from "@element-plus/icons-vue";
import { Download } from "@element-plus/icons-vue";
import { Menu } from "@element-plus/icons-vue";
import { Lock, CollectionTag } from "@element-plus/icons-vue";

import { useRouter, useRoute } from "vue-router";
import dayjs from "dayjs";
import { reactive } from "vue";
import { Star } from "@element-plus/icons-vue";
import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";

import column from "@/components/column/index.vue";

import rowBookCards from "@/components/rowBookCards/index.vue";
// 引入接口
import { articleInfo } from "@/api/home/index.js";
import { ElMessage, ElMessageBox } from "element-plus";

// 引入加入收藏、取消收藏接口
import {
  addFavoritesList,
} from "@/api/personalCenter/myCollection/index.js";
// 引入详情页取消收藏接口
import { cancelCollect } from "@/api/addedServices/index.js";
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  ulLi: [
    {
      id: "1",
      title: "二轮复习必备神器二轮复习必备神器轮复习必备神器",
    },
    {
      id: "2",
      title: "二轮复习必备神器二轮",
    },
    {
      id: "3",
      title: "二轮复习必",
    },
    {
      id: "4",
      title: "二轮复习必备神器二轮复习必备神",
    },
    {
      id: "5",
      title: "二轮复习必备神器二轮复",
    },
  ],
  title1: "新书上架",
  title2: "热门资源",
  title3: "适合项目",
  articleId: null, // 文章id值
  articleInfo: {}, // 文章详情

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

// 初始化函数
function init() {
  // 获取到传递过来的参数
  mydata.articleId = route.query.id;
  // 调用接口获取文章详情
  articleInfo({ id: mydata.articleId }).then((res) => {
    // console.log(res);
    mydata.articleInfo = res.data;
  });
}

init();

/**加入收藏/取消收藏的点击事件  0未收藏  1已收藏 */
function isCollect() {
  if (mydata.articleInfo.is_collect !== 0) {
    // 调用取消收藏接口
    cancelCollect(mydata.userInfo.jwt, {
      content_id: mydata.articleInfo.id,
      type: 3,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      init();
    });
  } else {
    // 调用加入收藏接口  类型(1:试卷,2:图书,3:文章,4:活动,5:视频)
    addFavoritesList(mydata.userInfo.jwt, {
      content_id: mydata.articleInfo.id,
      type: 3,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      init();
    });
  }
}

///我要加入按钮————教师活动报名
function teacherButton() {
  router.push({
    path: "/layout/list/thisEventRegistrationTeacher",
  });
}
</script>

<style scoped lang="scss">
.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 300px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 300px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 300px;
  //   // padding:30px;
  // }

  ////////最顶部的title
  .title-box {
    width: 1200px;
    margin: 0 auto;
    // border: 1px solid blue;
    margin-top: 40px;
    margin-bottom: 20px;
    .title {
      width: 1200px;
      height: 20px;
      // border: 1px solid red;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title-left {
        // width:200px;
        // border:1px solid blue;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #bbbdbf;
        .line {
          margin: 0px 8px;
        }
        p:hover {
          color: #009de0;
        }
      }
      .title-right {
        // width:60px;
        font-size: 16px;
        font-weight: 400;
        color: #bbbdbf;
        display: flex;
        align-items: center;
        // position:relative;
        // border:1px solid blue;

        cursor: pointer;
        .el-icon {
          font-size: 24px;
          font-weight: 400;
          margin-right: 4px;
        }
      }
      .collectTrue {
        color: #009de0;
      }

      .title-right:hover {
        color: #009de0;
      }
    }
  }
  // :deep(.books-details.layout-router-view.box1){
  //   margin-bottom:0px !important;
  // }
  //////内容部分
  .box-content {
    width: 1200px;
    // border: 1px solid red;
    margin: 0 auto;
    margin-top: 21px;
    // margin-bottom:16px;
    display: flex;
    justify-content: space-between;

    /////左边内容部分
    .content-left {
      width: 1200px;
      // height: 1608px;
      // border: 1px dashed rgb(102, 255, 0);
      background-color: #f9f9f9;
      // margin:0 auto;
      ////左边---第一个模块---卷子标题盒子
      .left-one {
        width: 1200px;
        background-color: #ffffff;
        padding: 30px;
        .one-title {
          // width: 800px;
          // height: 90px;
          // border: 1px solid red;
          p:nth-of-type(1) {
            min-height: 28px;
            font-size: 18px;
            font-weight: 700;
            color: #333333;

            line-height: 28px;
            // height: 56px;
            display: -webkit-box;
            -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
            text-overflow: ellipsis; //文本溢出 用省略号显示
            -webkit-line-clamp: 2; //几行
            overflow: hidden;
          }
          p:nth-of-type(2) {
            display: flex;
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            color: #888888;
            margin-top: 12px;
            > span {
              margin-right: 34px;
            }
          }
        }
        .one-content {
          // width: 800px;
          // height:1824px;
          // border: 1px solid blue;
          margin-top: 24px;
          img {
            // max-width: 1140px;
            // max-height: px;
            margin: 0 auto;
            display: block;
            // border:1px solid yellow;
          }
          p {
            margin-top: 24px;
            white-space: pre-wrap;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            // color:red;
          }
        }
        // .one-button {
        //   //按钮
        //   :deep(.el-button.el-button--primary.is-round) {
        //     width: 170px;
        //     height: 46px;
        //     border-radius: 30px;
        //     color: #ffffff;
        //     font-size: 14px;
        //     font-weight: 400;
        //     margin: 0 auto;
        //     display: block;
        //     margin-top: 26px;
        //   }
        // }
        // .one-foot {
        //   width: 800px;
        //   height: 84px;
        //   border: 1px solid red;
        //   border-top: 1px dashed #cccccc;
        //   margin-top: 26px;
        //   p {
        //     font-size: 14px;
        //     font-weight: 400;
        //     color: #333333;
        //     line-height: 22px;
        //   }
        //   p:nth-of-type(1) {
        //     margin-top: 24px;
        //   }
        //   p:nth-of-type(2) {
        //     margin-top: 16px;
        //   }
        //   p:hover {
        //     color: #009de0;
        //   }
        // }
      }

      ////左边---第二个模块
      // .left-two {
      //   width: 1200px;
      //   height: 277px;
      //   margin: 0 auto;
      //   margin-top: 26px;
      //   padding: 30px;
      //   // border: 1px solid blue;
      //   background-color: #ffffff;
      //   //////适合项目部分
      //   .left-two-box {
      //     width: 800px;
      //     // height: 228px;
      //     // border: 1px dashed yellow;
      //     overflow: hidden;

      //     //////////column组件
      //     :deep(.box-column) {
      //       // border: 1px solid red;
      //       width: 800px;
      //       height: 100%;
      //       padding: 0px;
      //       .column-title {
      //         font-size: 20px;
      //         font-weight: 400;
      //         color: #333333;
      //         padding-bottom: 8px;
      //       }
      //       li {
      //         margin-left: 20px;
      //         // display: flex;
      //         // justify-content: space-between;
      //         // align-items: center;
      //         margin-bottom: 20px;
      //         // border:1px solid red;
      //         position: relative;
      //         p {
      //           font-size: 16px;
      //           font-weight: 400;
      //           color: #888888;
      //           position: absolute;
      //           right: 0px;
      //           top: 0px;
      //         }
      //       }
      //       li:nth-last-of-type(1) {
      //         margin-bottom: 0px;
      //       }
      //       .column-content {
      //         margin-top: 30px;
      //         height: 156px;
      //         overflow: hidden;
      //       }
      //     }
      //   }
      // }
    }
  }
}
</style>